// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/scss/app.scss
// module id = ./assets/scss/app.scss
// module chunks = 0